var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 16,
    viewBox: "0 0 118 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7122 0V16H17.4352V5.59543L13.6915 15.9817H9.0207L5.27692 5.59543V15.9817H0V0H7.70147L11.3561 10.5143L15.0108 0H22.7122Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8476 13.5314H30.3066L29.326 16H23.8174L31.0197 0H37.1168L44.3368 16H38.8281L37.8476 13.5314ZM36.3857 9.81943L34.0682 4.04114L31.7684 9.81943H36.3857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8729 10.8069H50.7369V16H45.4601V0H56.5487C60.8452 0 63.2161 2.02971 63.2161 5.30286C63.2161 7.71657 62.0217 9.27086 60.0251 10.0937L63.7154 15.9817H58.0284L54.8729 10.8069ZM50.7369 7.14971H55.8C57.3509 7.14971 57.8501 6.32686 57.8501 5.30286C57.8501 4.26057 57.2083 3.712 55.8 3.712H50.7369V7.14971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2009 7.99086C83.2009 14.7383 78.2627 15.9817 73.378 15.9817H65.0525V0H73.378C78.2627 0 83.2009 1.28 83.2009 7.99086ZM77.8705 7.99086C77.8705 3.87657 75.3568 3.69371 72.2192 3.69371H70.3473V12.3063H72.2014C75.3568 12.3063 77.8705 12.1234 77.8705 7.99086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2961 0V16H85.0013V0H90.2961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8193 0V16H92.5245V0H97.8193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 0V16H112.402L105.325 6.49143V16H100.048V0H105.646L112.723 9.52686V0H118Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_148"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b864c3d3ca91cf90ed6a343360839a71.svg";
export { ForwardRef as ReactComponent };